import { Notification } from 'element-ui';

function downloadFileInBackground(url, fileName = 'downloaded-file') {
    const loadingNotification = Notification({
        message: `
            <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                <i class="el-icon-loading" style="margin-right: 10px;"></i> Preparing your file...
            </p>
            <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">
                Please wait while we prepare your file for download.
            </p>
        `,
        duration: 0,
        dangerouslyUseHTMLString: true,
    });

    // Trigger the file download asynchronously
    setTimeout(() => {
        fetch(url, { method: 'GET' })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch the file');
                }
                return response.blob();
            })
            .then(blob => {
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);  // Clean up the blob URL

                loadingNotification.close();
                Notification({
                    message: `
                            <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                                <i class="el-icon-success" style="margin-right: 10px; color: green;"></i> Download Successful
                            </p>
                            <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">
                                Your file "${fileName}" has been downloaded successfully.
                            </p>
                        `,
                    duration: 3000,
                    dangerouslyUseHTMLString: true,
                });
            })
            .catch(error => {
                console.error('Error downloading the file:', error);
                loadingNotification.close();
                Notification({
                    message: `
                            <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                                <i class="el-icon-error" style="margin-right: 10px; color: red;"></i> Download Error
                            </p>
                            <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">
                                There was an error downloading file
                            </p>
                        `,
                    duration: 3000,
                    dangerouslyUseHTMLString: true,
                });
            });
    }, 0);
}

async function downloadFileInBackgroundPdf(url, fileName = 'agreement.pdf') {
    const loadingNotification = Notification({
        message: `
            <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                <i class="el-icon-loading" style="margin-right: 10px;"></i> Preparing your file...
            </p>
            <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">
                Please wait while we prepare your file for download.
            </p>
        `,
        duration: 0,
        dangerouslyUseHTMLString: true,
    });

    try {
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch the file');
        }

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

        loadingNotification.close();
        Notification({
            message: `
                <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                    <i class="el-icon-success" style="margin-right: 10px; color: green;"></i> Download Started
                </p>
                <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">
                    Your file is being downloaded.
                </p>
            `,
            duration: 3000,
            dangerouslyUseHTMLString: true,
        });
    } catch (error) {
        console.error('Error downloading PDF file:', error);
        try {
            window.open(url, '_blank', 'noopener,noreferrer');
        } catch (openError) {
            console.error('Failed to open fallback download tab:', openError);
        }
        loadingNotification.close();
        Notification({
            message: `
                <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                    <i class="el-icon-error" style="margin-right: 10px; color: red;"></i> Download Fallback Opened
                </p>
                <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">
                    File opened in a new tab because direct download failed.
                </p>
            `,
            duration: 3500,
            dangerouslyUseHTMLString: true,
        });
    }
}

async function downloadMediaBackground(url, fileName = 'downloaded-file') {
    const loadingNotification = Notification({
        message: `
            <p style="color: #000; font-size: 20px; font-weight: bold;">
                <i class="el-icon-loading" style="margin-right: 10px;"></i> Preparing your file...
            </p>
            <p style="color: #000; font-size: 14px; margin-top: 10px;">
                Please wait while we prepare your file for download.
            </p>
        `,
        duration: 0,
        showClose: false,
        dangerouslyUseHTMLString: true,
    });

    try {
        const response = await fetch(url, {
            method: 'GET'
        });

        if (!response.ok) throw new Error('Failed to fetch the file');

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(blobUrl);

        loadingNotification.close();
        Notification({
            message: `
                <div style="display: flex; align-items: center; gap: 10px; color: #2ecc71;">
                    <i class="el-icon-circle-check" style="font-size: 18px;"></i>
                    <span style="font-size: 15px;">Download Successful: "${fileName}"</span>
                </div>
            `,
            duration: 2500,
            dangerouslyUseHTMLString: true,
        });

    } catch (error) {
        console.error('Error downloading the file:', error);
        loadingNotification.close();
        Notification({
            message: `
                <div style="display: flex; align-items: center; gap: 10px; color: #e74c3c;">
                    <i class="el-icon-circle-close" style="font-size: 18px;"></i>
                    <span style="font-size: 15px;">Download Failed</span>
                </div>
            `,
            duration: 3000,
            dangerouslyUseHTMLString: true,
        });
    }
}

function downloadFileInBackgroundCleanID(url, fileName = 'downloaded-file') {
    const loadingNotification = Notification({
        message: `
            <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                <i class="el-icon-loading" style="margin-right: 10px;"></i> Preparing your file...
            </p>
            <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">
                Please wait while we prepare your file for download.
            </p>
        `,
        duration: 0,
        dangerouslyUseHTMLString: true,
    });

    // Trigger the file download asynchronously
    setTimeout(() => {
        fetch(url, { method: 'GET' })
            .then(async response => {
                if (!response.ok) {
                    let message = 'Failed to fetch data';

                    try {
                        const json = await response.json();
                        if (json && json.message) {
                            message = json.message;
                        }
                    } catch (e) {}

                    throw new Error(message);
                }

                return response;
            })
            .then(async response => {
                // 1. Coba baca JSON, jika berhasil berarti ini balasan "file_download"
                try {
                    const clone = response.clone();
                    const json = await clone.json();
                    
                    if (json.file_download) {
                        // langsung download dari spaces
                        const link = document.createElement('a');
                        link.href = json.file_download;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        loadingNotification.close();
                        Notification({
                            message: `
                                <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                                    <i class="el-icon-success" style="margin-right: 10px; color: green;"></i> Download Successful
                                </p>
                                <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">Your file "${fileName}" has been downloaded.</p>
                            `,
                            duration: 3000,
                            dangerouslyUseHTMLString: true,
                        });

                        return; // stop - jangan ke blob
                    }
                } catch (e) { // JSON gagal → berarti backend kirim file Blob
                    console.log(`response is blob, error: ${e}`)
                }

                // 2. Kalau bukan JSON, proses blob seperti biasa
                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);

                loadingNotification.close();
                Notification({
                    message: `
                        <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                            <i class="el-icon-success" style="margin-right: 10px; color: green;"></i> Download Successful
                        </p>
                        <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">Your file "${fileName}" has been downloaded.</p>
                    `,
                    duration: 3000,
                    dangerouslyUseHTMLString: true,
                });
            })
            .catch(error => {
                console.error('Download error:', error);
                const message = error && error.message ? error.message : 'There was an error downloading the file.';
                loadingNotification.close();
                Notification({
                    message: `
                        <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                            <i class="el-icon-error" style="margin-right: 10px; color: red;"></i> Download Error
                        </p>
                        <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">${message}</p>
                    `,
                    duration: 6000,
                    dangerouslyUseHTMLString: true,
                });
            });
    }, 0);
}

export { downloadFileInBackground, downloadFileInBackgroundPdf, downloadMediaBackground, downloadFileInBackgroundCleanID }